import { Link } from 'react-router-dom';
import { useReveal } from '../hooks/useReveal';
import { useBloco, useServicos } from '../content';
import ServiceCard from './ServiceCard';

export default function Portfolio() {
  const headRef = useReveal();
  const gridRef = useReveal();
  const c = useBloco('home.portfolio');
  const services = useServicos();

  const destaques = services
    .slice(0, c.featuredCount)
    .map((s) => ({ ...s, variant: 'dark c6' }));

  return (
    <section className="section" id="servicos">
      <div className="portfolio-head reveal" ref={headRef}>
        <div>
          <div className="lbl">{c.eyebrow}</div>
          <h2>{c.heading} <em>{c.headingEm}</em></h2>
        </div>
        <p>{c.paragraph}</p>
      </div>

      <div className="svc-grid reveal" ref={gridRef}>
        {destaques.map((svc) => (
          <ServiceCard key={svc.id} {...svc} />
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: 40 }}>
        <Link to="/servicos" className="btn-primary d-inline-flex">
          <span>{c.cta}</span>
        </Link>
      </div>
    </section>
  );
}
